import { useEffect, useState } from "react";
import { Button, Group, Modal, Stack, TextInput } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { advancedSearchSaveFilter } from "../../../services/rules";
import { getAxiosResponseError } from "../../../utils/functions";
import { ruleQueryKey } from "../../../components/QueryBuilder/hooks/queryKeys";

/**
 * Save Filter modal. Captures a name and POSTs to
 * advancedSearchSaveFilter. The trigger button is rendered alongside
 * the modal so the parent doesn't need to manage open/close state.
 */
export default function SaveFilterModal({ ruleId, defaultName = "" }) {
  const queryClient = useQueryClient();
  const [opened, { open, close }] = useDisclosure(false);
  const [name, setName] = useState("");

  useEffect(() => {
    if (opened) setName(defaultName);
    else setName("");
  }, [opened, defaultName]);

  const mutation = useMutation({
    mutationFn: advancedSearchSaveFilter,
    onSuccess: () => {
      toast.success("Filter Saved!");
      queryClient.invalidateQueries({ queryKey: ruleQueryKey(ruleId) });
      close();
    },
    onError: (err) => toast.error(getAxiosResponseError(err)),
  });

  return (
    <>
      <Button variant="outline" onClick={open}>
        Save Filter
      </Button>
      <Modal
        opened={opened}
        onClose={close}
        title="Save Filter"
        centered
        size="md"
      >
        <Stack gap="md">
          <TextInput
            placeholder="Enter filter name"
            value={name}
            onChange={(ev) => setName(ev.currentTarget.value)}
            autoFocus
          />
          <Group justify="space-between">
            <Button variant="outline" color="red" onClick={close}>
              Cancel
            </Button>
            <Button
              color="green"
              variant="outline"
              disabled={!name}
              loading={mutation.isPending}
              onClick={() => mutation.mutate({ ruleId, name })}
            >
              Save
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
}
